<template>
<div>

<!--
<ContentHeader v-if="project_supplier"  :title="getTheTranslation(project_supplier.project,'translation')"  :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don" url="SupplierProjectAllPeriods" :urlparams="headerurlparams"></ContentHeader>

-->


<div class="contenttopbar grid px-3 mt-1" v-if="project_supplier">
<div class="col-8 ">
<h3 class="text-primary mb-3 mt-3 font-medium">{{getTheTranslation(project_supplier.project,'translation')}}</h3>
</div>

<div class="col-4 ">

<div class="flex align-items-center justify-content-end">

<div class="hide_on_mobile mr-2"><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2" :label="$store.state.languages.lang_phrases.proje_gecmisi" icon="pi pi-history" @click="showHistory" /></div>
<div class="show_on_mobile mr-2"><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2" icon="pi pi-history" @click="showHistory" /></div>

<div class="hide_on_mobile "><Button type="button" class="p-button-danger p-button-outlined p-button-sm mt-2" :label="$store.state.languages.lang_phrases.geri_don" icon="pi pi-arrow-left" @click="goBack" /></div>
<div class="show_on_mobile"><Button type="button" class="p-button-danger p-button-outlined p-button-sm mt-2" icon="pi pi-arrow-left" @click="goBack" /></div>



</div>
</div>
</div>






<div class="content_card" >
<div class="grid">
<div class="col-12">
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<div class=" evaluation_wrap" v-if="!loading">

<div class="grid">

<!-- text -->
<div class="col-12 md:col-5 p-3">
<div class="grid content_card_content">
<div class="col-3 md:col-3"><p class="click_edit_value_title" >{{$store.state.languages.lang_phrases.sorumlu_marka}}:</p></div>
<div class="col-9 md:col-9 mt-0" ><p class="click_edit_value" ><router-link class="text-primary no-underline font-medium" :to="{ name: 'BrandGeneral', params: { id: project_supplier.project.brand.id }}">{{project_supplier.project.brand.name}}</router-link></p></div>


<div class="col-3 md:col-3"><p class="click_edit_value_title" >{{$store.state.languages.lang_phrases.proje_ismi}}:</p></div>
<div class="col-9 md:col-9 mt-0" ><p class="click_edit_value" ><router-link class="text-primary no-underline font-medium" :to="{ name: 'ProjectGeneral', params: { id: project_supplier.project.id }}">{{project_supplier.project.name}}</router-link></p></div>

<div class="col-3 md:col-3"><p class="click_edit_value_title" >{{$store.state.languages.lang_phrases.proje_donemi}}:</p></div>
<div class="col-9 md:col-9 mt-0" ><p class="click_edit_value" >{{project_supplier.projectperiod.name}}</p></div>

<div class="col-12">
<ClickEditSelect :title="$store.state.languages.lang_phrases.proje_durumu" :value="project_supplier.status" :options="project_statuses" valkey="status" @dataChanged="projectSupplierStatusChanged" label_width="wide" />
</div>

<div class="col-12">
<ClickEditSwitch  :title="$store.state.languages.lang_phrases.verified" :value="project_supplier.verified" valkey="verified" @dataChanged="switchVerified" label_width="wide"/>
</div>


</div>
</div>
<!-- text -->

<div class="col-12 md:col-7 p-3">
<div class="grid content_card_content">
<div class="col-12 md:col-12"><p >
<b class="text-primary">{{$store.state.languages.lang_phrases.proje_akislari}}</b>

<template v-if="flowsuppliers.length">
 <b class="text-purple-500"> - {{flowsuppliers.length}} {{$store.state.languages.lang_phrases.akis}}</b>
</template>
</p>


</div>
<div class="col-12 ">
<ScrollPanel style="width: 100%; height: 268px">
<CollapsableFlowCard viewer="admin" v-for="item in flowsuppliers" :flowsupplier="item" :activeflow="project_supplier.activeflow" @activeFlowUpdated="activeFlowUpdated"></CollapsableFlowCard>
</ScrollPanel>


</div>

</div>
</div>



</div>
</div>
</div>
</div>

</div>

<VerificationDataTransferModal ></VerificationDataTransferModal>






<Sidebar v-model:visible="historysidebar" header="Sidebar" position="right" class="w-full md:w-30rem lg:w-30rem">
<h3 class="text-primary">{{$store.state.languages.lang_phrases.proje_gecmisi}}</h3>
<hr>
<template v-if="loading_history">
<FrameOverlay></FrameOverlay>
</template>

<template v-else>
<ScrollPanel style="width: 100%; height: 80vh">
<div class="grid" v-for="item in projectsupplier_history">
<div class="col-4">
  <template v-if="item.user">
    <small class="text-primary" v-tooltip.left="{ value: item.user.email, disabled: false,class: 'custom-top-tooltip' }"><b> {{item.user.name}}</b></small>
  </template>
  <template v-else>
    <small class="text-primary"><b> System</b></small>
  </template>

</div>
<div class="col-4">
<small class="text-purple-500"><b>{{ $filters.momentFormat( item.created_at," Do-MM-YYYY HH:mm")}}</b></small>
</div>
<div class="col-4">
<Tag 
class="ml-2   custom-chip" 
:value="getHistoryItemTag(item).name" 
:style="'background-color:'+getHistoryItemTag(item).color"
/>
</div>

<div class="col-12">
<hr>
</div>

</div>
</ScrollPanel>

  
</template>


</Sidebar>


</div>
</template>

<script>
import SupplierProjectFlow from "./SupplierProjectFlow"
export default {

  name: 'SupplierProject',

  components:{SupplierProjectFlow},
  data () {
    return {
      loading:true,
      project_supplier:null,
      flowsuppliers:[],
      projectsupplier_history:[],
      loading_history:true,
      historysidebar:false,
      project_statuses:[
      {name:"Oluşturuldu",id:"created"},
      {name:"Başlandı",id:"started"},
      {name:"Devam Ediyor",id:"in_progress"},
      {name:"Tamamlandı",id:"finished"},
      {name:"İptal",id:"canceled"},
      ]
    }
  },
  mounted()
  {

    this.$store.dispatch('ui/setActiveTab',"projeler") 
    this.getData()
  },
  computed:{
    headerurlparams()
    {
      return {project_id:this.project_supplier.project_id}
    },
  },
  methods:{
    goBack()
    {
      console.log(this.project_supplier)
      let url_params = {project_id:this.project_supplier.project.id}
      this.$router.push({ name:  "SupplierProjectAllPeriods", params: url_params }) 
    },
    async showHistory()
    {
      
      this.historysidebar = true
      this.loading_history = true

      console.log(this.$route.params.project_id)      

      this.projectsupplier_history = await this.generalApiGetWithoutLoader("audit/get_projectsupplier_history/"+this.$route.params.project_id) 
      console.log(this.projectsupplier_history)
      this.loading_history = false
    },
    getHistoryItemTag(item)
    {
      let name
      let color
      if(item.status=="created")
      {
        name =  this.$store.state.languages.lang_phrases.olusturuldu
      }
      if(item.status=="viewed")
      {
        name =  this.$store.state.languages.lang_phrases.goruntulendi
      }
      if(item.status=="started")
      {
        name =  this.$store.state.languages.lang_phrases.baslandi
      }

      if(item.status=="deleted")
      {
        name =  this.$store.state.languages.lang_phrases.silindi
      }
      if(item.status=="finished")
      {
        name =  this.$store.state.languages.lang_phrases.tamamlandi0
      }
      if(item.status=="under_review")
      {
        name =  this.$store.state.languages.lang_phrases.degerlendirmede
      }
      if(item.status=="canceled")
      {
        name =  this.$store.state.languages.lang_phrases.iptal_edildi
      }
      if(item.status=="correction_requested")
      {
        name =  this.$store.state.languages.lang_phrases.duzeltme_talebi_incelemede
      }
      if(item.status=="recalculated")
      {
        name =  this.$store.state.languages.lang_phrases.tekrar_hesaplandi
      }
      if(item.status=="active_flow_updated")
      {
        name =  this.$store.state.languages.lang_phrases.aktif_asama_guncellendi
      }

      if(item.status=="created")
      {
        color =  "#352f8d"
      }
      if(item.status=="viewed")
      {
        color = "#7e2f8d"
      }
      if(item.status=="started")
      {
        color = "#dd4b39"
      }
      if(item.status=="deleted")
      {
        color = "#dd4b39"
      }
      if(item.status=="finished")
      {
        color = "#4dc247"
      }
      if(item.status=="under_review")
      {
        color = "#ff6600"
      }
      if(item.status=="canceled")
      {
        color = "#a82400"
      }
      if(item.status=="correction_requested")
      {
        color = "#3b82f6"
      }
      if(item.status=="recalculated")
      {
        color = "#3b82f6"
      }
      if(item.status=="active_flow_updated")
      {
        color = "#3b82f6"
      }

      return {
        name:name,
        color:color
      }

    },
    projectSupplierStatusChanged(data)
    {
      console.log(data)      
      let formdata = new FormData()
      formdata.append("status",data.value)
      this.generalSubmission(formdata,"audit/update_project_supplier_status/"+this.project_supplier.id,this.afterprojectSupplierStatusChanged)
    },
    afterprojectSupplierStatusChanged(response)
    {
      //this.project_supplier = response.data
      this.getData()
    },
    switchVerified(data)
    {
      console.log(data) 
      let formdata = new FormData()
      formdata.append("status",data.value)
      this.generalSubmission(formdata,"audit/update_project_supplier_verified_status/"+this.project_supplier.id,this.afterprojectSupplierStatusChanged)
    },
    activeFlowUpdated(data)
    {
      this.project_supplier.activeflow = data.activeflow
    },
    orderFlowsuppliers(flowsuppliers)
    {
      //let theflowsuppliers = this.sanitizeArray(flowsuppliers)
      this.flowsuppliers = []
      for(let flow of this.project_supplier.project.flows)
      {
        let item = flowsuppliers.find((element)=>{return element.flow_id == flow.id})
        if(item)
        {
          this.flowsuppliers.push(item)
        }
      }
    },
    async getData()
    {
      this.loading = await true
     let data = await this.generalApiGetWithoutLoader("audit/project_supplier/"+this.$route.params.project_id) 
      
      this.project_supplier = await data.project_supplier
      //this.flowsuppliers = await data.flow_suppliers
      await this.orderFlowsuppliers(data.flow_suppliers)
      this.loading = await false
      console.log("project_supplier");
      console.log(data);
    },

  },
}
</script>

<style lang="css" scoped>
</style>